import { Language } from "../LangSelector/types";
import { GithubIcon, TelegramIcon, TwitterIcon } from "../Svg";
import { FooterLinkType } from "./types";

export const footerLinks: FooterLinkType[] = [
  {
    label: "About",
    items: [
      {
        label: "Contact",
        href: "https://docs.app.squirrelsociety.vip/contact-us",
      },
      {
        label: "Blog",
        href: "https://blog.app.squirrelsociety.vip/",
      },
      {
        label: "Community",
        href: "https://docs.app.squirrelsociety.vip/contact-us/telegram",
      },
      {
        label: "CAKE",
        href: "https://docs.app.squirrelsociety.vip/tokenomics/cake",
      },
      {
        label: "—",
      },
      {
        label: "Online Store",
        href: "https://pancakeswap.creator-spring.com/",
        isHighlighted: true,
      },
    ],
  },
  {
    label: "Help",
    items: [
      {
        label: "Customer",
        href: "Support https://docs.app.squirrelsociety.vip/contact-us/customer-support",
      },
      {
        label: "Troubleshooting",
        href: "https://docs.app.squirrelsociety.vip/help/troubleshooting",
      },
      {
        label: "Guides",
        href: "https://docs.app.squirrelsociety.vip/get-started",
      },
    ],
  },
  {
    label: "Developers",
    items: [
      {
        label: "Github",
        href: "https://github.com/pancakeswap",
      },
      {
        label: "Documentation",
        href: "https://docs.app.squirrelsociety.vip",
      },
      {
        label: "Bug Bounty",
        href: "https://app.gitbook.com/@pancakeswap-1/s/pancakeswap/code/bug-bounty",
      },
      {
        label: "Audits",
        href: "https://docs.app.squirrelsociety.vip/help/faq#is-pancakeswap-safe-has-pancakeswap-been-audited",
      },
      {
        label: "Careers",
        href: "https://docs.app.squirrelsociety.vip/hiring/become-a-chef",
      },
    ],
  },
];

export const socials = [
  {
    label: "Twitter",
    icon: TwitterIcon,
    href: "https://twitter.com/404Squirrels",
  },
  {
    label: "Telegram",
    icon: TelegramIcon,
    href: "https://t.me/SecretSquirrelSociety",
  },
  /*
  {
    label: "Reddit",
    icon: RedditIcon,
    href: "https://reddit.com/r/pancakeswap",
  },
  */
  /*
  {
    label: "Instagram",
    icon: InstagramIcon,
    href: "https://instagram.com/pancakeswap_official",
  },
  */
  {
    label: "Github",
    icon: GithubIcon,
    href: "https://github.com/SecretSquirrelSociety/",
  },
  /*
  {
    label: "Discord",
    icon: DiscordIcon,
    href: "https://discord.gg/pancakeswap",
  },
  /*
  {
    label: "Youtube",
    icon: YoutubeIcon,
    href: "https://www.youtube.com/@pancakeswap_official",
  },
  */
];

export const langs: Language[] = [...Array(20)].map((_, i) => ({
  code: `en${i}`,
  language: `English${i}`,
  locale: `Locale${i}`,
}));
